import * as z from "zod/v4";
import {
  returnsAnalyticsDataQualitySchema,
  returnsRevenueBundleSchema,
} from "./returns-analytics-shared";

export const getReturnsPipelineFunnelInputSchema = z.object({
  startDate: z.string().min(1).optional(),
  endDate: z.string().min(1).optional(),
  /**
   * When true, rows for stages with zero deals in the range are still
   * returned (useful for drawing a consistent funnel chart).
   */
  includeEmptyStages: z.boolean().default(true),
});
export type GetReturnsPipelineFunnelInput = z.infer<
  typeof getReturnsPipelineFunnelInputSchema
>;

const stageRowSchema = z.object({
  stageNormalized: z.string(),
  stageLabel: z.string(),
  displayOrder: z.number().int(),
  isClosedWon: z.boolean(),
  isClosedLost: z.boolean(),
  isLive: z.boolean(),
  dealCount: z.number().int().min(0),
  revenue: returnsRevenueBundleSchema,
  avgDaysInStage: z.number().min(0).nullable(),
  avgDaysSinceCreate: z.number().min(0).nullable(),
  linkedToOnboardingCount: z.number().int().min(0),
  selfServeCompletedCount: z.number().int().min(0),
});
export type ReturnsPipelineStageRow = z.infer<typeof stageRowSchema>;

export const getReturnsPipelineFunnelOutputSchema = z.object({
  stages: z.array(stageRowSchema),
  dataQuality: returnsAnalyticsDataQualitySchema,
});
export type GetReturnsPipelineFunnelOutput = z.infer<
  typeof getReturnsPipelineFunnelOutputSchema
>;

export const getReturnsPipelineFunnel = {
  name: "getReturnsPipelineFunnel" as const,
  input: getReturnsPipelineFunnelInputSchema,
  output: getReturnsPipelineFunnelOutputSchema,
};
